export const PAYMENT_ORIGINS = {
  upsellModalRecordings: 'Upsell Modal Recordings',
  vatCountryChange: 'VAT/Country changed',
  updatePaymentDetails: 'Update Payment Details',
  modalPlanChangeConfirmation: 'Modal Plan Change Confirmation',
  newSite: 'New Site',
  yearlyUpsell: 'Yearly Upsell Owner Modal',
  changeIndividualAgency: 'Agency/Individual Account change',
};
